<footer class="web-footer">
  <div class="footer-wrapper">
    <div class="top">
      <a class="logo" routerLink="/" aria-label="Avaana home">
        <img src="assets/images/website/avaana-logo-light.svg" alt="Avaana" width="99" height="26" />
      </a>
      @for (column of columns; track column) {
      <div class="column">
        <p class="title">{{ column.title }}</p>
        @for (item of column.links; track item) {
        <a [routerLink]="item.link">{{ item.label }}</a>
        }
      </div>
      }
      <div class="column">
        <p class="title">Providers</p>
        <a routerLink="/for-providers">For providers</a>
        <a href="#" (click)="$event.preventDefault(); openLogin($event)">Provider log in</a>
        <a routerLink="/provider-terms">Provider terms</a>
      </div>
    </div>
    <div class="bottom">
      <p>&copy; {{ currentYear }} Avaana, Pty Ltd. All rights reserved</p>
      <div class="legal">
        @for (item of legalLinks; track item) {
        <a [routerLink]="item.link">{{ item.label }}</a>
        }
      </div>
    </div>
  </div>
</footer>
